import api from './index';
//
let exports = {};
// 资产清单
exports.getAssetBasicBizdtlByFilter = function (data, callback) {
    api.post('/asset/bizdtl/basic/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getAssetTransBizdtlByFilter = function (data, callback) {
    api.post('/asset/bizdtl/trans/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getAssetBasicBizdtlMonthlyByFilter = function (data, callback) {
    api.post('/asset/bizdtl/basic/monthly/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 总账科目汇总明细
exports.getZzkmWorthSumdtlByFilter = function (data, callback) {
    api.post('/asset/bizdtl/zzkm/worth/sumdtl/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 总账核对
exports.doCheckZzkmWorthSumdtl = function (callback) {
    api.get('/asset/bizdtl/zzkm/worth/sumdtl/check/do')
    .done(callback)
    .fail(callback)
    .go();
};
// 初始余额
exports.doInitialZzkmWorthSumdtl = function (data, callback) {
    api.post('/asset/bizdtl/zzkm/worth/sumdtl/initial/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getAssetScrapBizdtlByFilter = function (data, callback) {
    api.post('/asset/bizdtl/scrap/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getAssetWorthLossBizdtlByFilter = function (data, callback) {
    api.post('/asset/bizdtl/loss/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/assetBizdtl.js
// module id = 166
// module chunks = 0